import { ChainId, Token, WETH } from "../../../libs/uniswap";
import { convert41to0x } from "../../../utils/tronweb/utils";
export const ShastaAddresses = {
    TOKEN_RING: "415e465875334b3960e6fc3f6e018ef70d66dedf15",
    TOKEN_KTON: "41fe4170545a81503a0a328a368f9e0d7c1f6a204c",
    TOKEN_WETH: "",
    ELEMENT_GOLD: "41ec0ff3527ddba81f0cf5101fb31dc42b808ca1ab",
    ELEMENT_WOOD: "41da966f8718feea81a500ab193838e2be208bf987",
    ELEMENT_WATER: "41e9eaec1529b2030e3704cb41f08fc4e15117add0",
    ELEMENT_FIRE: "41f9c329dbb1bc5f84ab731a7f0a64cd226c0cb1ab",
    ELEMENT_SOIL: "41d23d40f91f9dcd27218307351be1173ed43943c9",
    GOLD_RUSH_RAFFLE: "414de84fdcc7b32452f6fcecf2021458e41aceb0f0",
    PVETEAM_PROXY: "",
    MATERIAL_PROXY: "",
    MATERIALTAKEBACK_PROXY: "",
    CRAFTBASE_PROXY: "",
    LAND_CLOCK_AUCTION: "41a77b64c3751e29ed15c7ca936a219609b7974955",
    APOSTLE_CLOCK_AUCTION: "41441ceeff97d96c1d50173503c571915b2dc2b45f",
    SIRING_CLOCK_AUCTION: "419e7827155234ad4bd8102532de8c1dc74eb3aadc",
    APOSTLE_BASE: "41238fe04997359169aa65fe5b4631db220dfe540e",
    // LAND_RESOURCE: "41b36f434a28fcbc921b92182ca79af872b476cdc1",
    LAND_RESOURCE: "410CCE145A83F344E290613028EA3123EB473E69CB",
    TOKEN_USE: "4184793cf50f45330256265e7b14af096438057670",
    OBJECTOWNERSHIP: "410eb26cd69aba0f5f3b866747b014313a5ddef076",
    SETTINGSREGISTRY: "41d1fd927d8bf55bff2dfb8248047bc9881e710cc7",
    POINTS_REWARD_POOL: "41afdfc017691fd4665f4b70ccd5d297acb880dba1",
    TOKEN_USER_POINTS: "413bf3f7b094ef56acdf5e430756e43694ac83a6bb",
    FURNACE_TREASURE: "",
    FURNACE_ITEM_BASE: "",
    FURNACE_TAKEBACK: "",
    UNISWAP_EXCHANGE: "",
    STAKINGREWARDSFACTORY: "",
    GOLDRAFFLEPOOL_PROXY: "",
    WOODRAFFLEPOOL_PROXY: "",
    WATERRAFFLEPOOL_PROXY: "",
    FIRERAFFLEPOOL_PROXY: "",
    SOILRAFFLEPOOL_PROXY: "",
};
export const ShastaTokens = {
    RING: new Token(ChainId.SHASTA, convert41to0x(ShastaAddresses.TOKEN_RING), 18, "RING", "Darwinia Network Native Token"),
    KTON: new Token(ChainId.SHASTA, convert41to0x(ShastaAddresses.TOKEN_KTON), 18, "KTON", "Darwinia Network Commitment Token"),
    GOLD: new Token(ChainId.SHASTA, convert41to0x(ShastaAddresses.ELEMENT_GOLD), 18, "GOLD", "Evolution Land Token"),
    WOOD: new Token(ChainId.SHASTA, convert41to0x(ShastaAddresses.ELEMENT_WOOD), 18, "WOOD", "Evolution Land Token"),
    WATER: new Token(ChainId.SHASTA, convert41to0x(ShastaAddresses.ELEMENT_WATER), 18, "WATER", "Evolution Land Token"),
    FIRE: new Token(ChainId.SHASTA, convert41to0x(ShastaAddresses.ELEMENT_FIRE), 18, "FIRE", "Evolution Land Token"),
    SOIL: new Token(ChainId.SHASTA, convert41to0x(ShastaAddresses.ELEMENT_SOIL), 18, "SOIL", "Evolution Land Token"),
    WETH: WETH[ChainId.SHASTA],
};
